export interface IDocument {
  documentId?: string;
  id?: string;
  extractionStatus?: string;
  size?: number;
  name?: string;
  totalPages?: number;
  bucketName?: string;
  fileType?: string;
  pages?: IDocumentPages[];
  seqNumber?: number;
  /** Opening page when navigating from list to document detail */
  pageNumber?: number;
}

export interface IDocumentPages {
  id?: string;
  pageNumber?: number;
  documentCategory?: string;
  documentType?: string;
  businessName?: string;
  businessAddress?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  receivedByDate?: string;
  dateOfFiling?: string;
  comissionNumber?: string;
  businessId?: string;
  ownerName?: string;
  expirationDate?: string;
  currentExpirationDate?: string;
  newExpirationDate?: string;
  registrationNumber?: string;
  filingNumber?: string;
  dealerId?: string;
  dealerType?: string;
  issueDate?: string;
  incorporator?: string;
  secRegistrationNumber?: string;
  documentId?: string;
  // detail string
  calculatedDetails?: IDocumentPageCalculatedValue[];
}

export interface IGenerativeBusinessDocumentDTO {
  businessName: string;
  content: string;
  dateOfFiling: string;
  documentBucketName: string;
  documentCategory: string;
  documentId: string;
  documentName: string;
  documentTotalPages: number;
  ownerName: string;
  pageNumber: number;
  _id: string;
  id: string;
}

export interface IDocumentPageCalculatedValue {
  key: string;
  value: any;
}

export interface IDocumentListResponse {
  data: IDocument[];
  total: number;
}

export interface IDocumentPrint {
  pageIndex: number;
  pageNumber: number;
  isChecked: boolean;
}

export interface IDocumentFilter {
  type: string;
  formControlName: string;
  label: string;
}

export const states = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const dealerTypes = [
  "Automobile Auction",
  "Automotive Salvage Recycler",
  "Converter Manufacturer",
  "Dealer",
  "Distributor",
  "Manufacturer",
  "Mobility Dealer",
  "Transfer Dealer",
  "Watercraft Dealer",
];
